



























































































import { LabelQualityGoal } from '@/interfaces/types/QualityGoal';
import Input from '@/components/common/Input/Input.vue';
import Vue, { PropType } from 'vue';
import CustomSelect from '../common/Select/CustomSelect.vue';
import DeleteButton from '../common/Button/DeleteButton.vue';
import RadioButton from '../common/Button/FilterButton.vue';

import DistributionGoalInput from './QualityGoalInput/DistributionGoalInput.vue';
import QuantityGoalInput from './QualityGoalInput/QuantityGoalInput.vue';
import MinAvgMaxGoalInput from './QualityGoalInput/MinAvgMaxGoalInput.vue';
import TotalElementCountInput from './QualityGoalInput/TotalElementCountInput.vue';

const strDist = '분포 확인';
const strClassQuantity = '클래스 별 목표 수량';
const strMinAvgMax = '최소/평균/최대';
const strArrMinAvgMaxLen = '최소/평균/최대 배열 길이';
const strTotalElCnt = '전체 배열 요소 개수';
export default Vue.extend({
  components: {
    Input,
    CustomSelect,
    DeleteButton,
    RadioButton,
    DistributionGoalInput,
    QuantityGoalInput,
    MinAvgMaxGoalInput,
    TotalElementCountInput,
  },
  props: {
    labelQualityGoal: {
      type: Object as PropType<LabelQualityGoal>,
    },
    labelName: {
      type: String,
    },
    index: {
      type: Number,
    },
    isPostable: {
      type: Boolean,
    },
  },
  data(): {
    goalItemTypeList: { [key: string]: string[] };
    isItemTypeSelected: boolean[];
    labelType: string;
    selectedGoalType: string;
    localIsPostable: boolean;
    localLabelQualityGoal: LabelQualityGoal;
    inputContainer: {
      distributionRate: undefined | { [className: string]: number };
      classQuantity: undefined | { [className: string]: number };
      minAvgMaxValue:
        | undefined
        | { minValue: number; avgValue: number; maxValue: number };
      totalElementCount: undefined | number;
    };
    isInputValid: boolean;
  } {
    return {
      goalItemTypeList: {
        문자열: [strDist, strClassQuantity],
        숫자: [strDist, strMinAvgMax, strClassQuantity],
        배열: [strArrMinAvgMaxLen, strTotalElCnt],
        객체: [],
      },
      isItemTypeSelected: [false, false, false, false],
      labelType: '문자열',
      selectedGoalType: '',
      localIsPostable: this.isPostable,
      localLabelQualityGoal: this.labelQualityGoal,
      inputContainer: {
        distributionRate: undefined,
        classQuantity: undefined,
        minAvgMaxValue: undefined,
        totalElementCount: undefined,
      },
      isInputValid: false,
    };
  },
  computed: {
    isDistribution(): boolean {
      return this.selectedGoalType === strDist;
    },
    isClassQuantity(): boolean {
      return this.selectedGoalType === strClassQuantity;
    },
    isMinMax(): boolean {
      return this.selectedGoalType === strMinAvgMax;
    },
    isArrAvgLen(): boolean {
      return this.selectedGoalType === strArrMinAvgMaxLen;
    },
    isTotalElCnt(): boolean {
      return this.selectedGoalType === strTotalElCnt;
    },
    /**
     * 여러 속성을 하나의 watch 메소드로 감시하기 위한 패턴
     */
    compoundedPropertyForIsPostable(): (string | boolean)[] {
      return [
        this.selectedGoalType,
        this.localLabelQualityGoal.type,
        this.localLabelQualityGoal.labelName,
        this.localLabelQualityGoal.description,
        this.isInputValid,
      ];
    },
    compoundedQualityGoal(): LabelQualityGoal | undefined {
      if (this.localIsPostable) {
        const inputs = this.inputContainer;
        const rtQualityGoal: LabelQualityGoal = {
          type: this.localLabelQualityGoal.type,
          method: this.localLabelQualityGoal.method,
          labelName: this.localLabelQualityGoal.labelName,
          description: this.localLabelQualityGoal.description,
          distributionRate: inputs.distributionRate,
          classQuantity: inputs.classQuantity,
          average: inputs.minAvgMaxValue
            ? inputs.minAvgMaxValue.avgValue
            : undefined,
          minValue: inputs.minAvgMaxValue
            ? inputs.minAvgMaxValue.minValue
            : undefined,
          maxValue: inputs.minAvgMaxValue
            ? inputs.minAvgMaxValue.maxValue
            : undefined,
          elementCount: inputs.totalElementCount,
          reportOption: {
            showStandard: false,
            showEtc: false,
          },
        };
        return rtQualityGoal;
      } else {
        return undefined;
      }
    },
  },
  watch: {
    selectedGoalType: function (value: string, oldValue: string) {
      if (value !== oldValue) {
        this.inputContainer.distributionRate = undefined;
        this.inputContainer.minAvgMaxValue = undefined;
        this.inputContainer.totalElementCount = undefined;
      }
    },
    labelType: {
      handler: function (value: string, oldValue: string) {
        if (value !== oldValue) {
          this.selectedGoalType = '';
          this.isItemTypeSelected = [false, false, false, false];
        }
        switch (value) {
          case '문자열':
            this.localLabelQualityGoal.type = 'string';
            break;
          case '숫자':
            this.localLabelQualityGoal.type = 'number';
            break;
          case '배열':
            this.localLabelQualityGoal.type = 'array';
            break;
          case '객체':
            this.localLabelQualityGoal.type = 'object';
            break;
          default:
            this.localLabelQualityGoal.type = '';
        }
      },
      immediate: true,
    },
    compoundedQualityGoal: {
      handler: function () {
        this.$emit('update:labelQualityGoal', this.compoundedQualityGoal);
      },
      deep: true,
    },
    compoundedPropertyForIsPostable: {
      handler: function (value: string[]) {
        const [selectedGoalType, labelType, labelName, description, isValid] =
          value;

        const postable =
          !!selectedGoalType &&
          !!labelType &&
          !!labelName &&
          !!description &&
          !!isValid;
        this.localIsPostable = postable;

        this.$emit('update:isPostable', this.localIsPostable);
      },
      deep: true,
    },
    inputContainer: {
      handler: function (value: {
        distributionRate: undefined | { [className: string]: number };
        average: undefined | number;
        minAvgMaxValue: undefined | { minValue: number; maxValue: number };
        arrayMinAvgMaxLength: undefined | number;
        totalElementCount: undefined | number;
      }) {
        const values = Object.values(value);
        this.isInputValid = values.some((val) => val !== undefined);
      },
      deep: true,
    },
  },
  methods: {
    deleteItem() {
      this.$emit('deleteItem', this.index);
    },
    onClickRadioButton(index: number) {
      this.isItemTypeSelected = [false, false, false, false];
      this.isItemTypeSelected[index] = true;
      const st = this.goalItemTypeList[this.labelType][index];
      this.selectedGoalType = st;
      this.localLabelQualityGoal.method =
        st === strDist
          ? 'dist'
          : st === strClassQuantity
          ? 'classQuantity'
          : st === strMinAvgMax
          ? 'minAvgMax'
          : st === strArrMinAvgMaxLen
          ? 'arrLenMinAvgMax'
          : st === strTotalElCnt
          ? 'arrElCnt'
          : '';
    },
  },
});
